/**
* Created by bieao on 2020/4/1.
*/
<template>
  <div class="item-position alarm-content">
    <div class="title-item">
      <div class="first"></div>
      <div class="two">02</div>
      <div class="title">
        <div>Real-time Alarm</div>
        <div>实时报警</div>
      </div>
    </div>
    <div class="content-body">
      <dv-scroll-board :config="data" class="latest-table" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlarmMonitor',
  props: {
    data: {
      type: Object
    }
  }
}
</script>

<style scoped lang="scss">
  .latest-table{
    width: 480px;
    height: 382px;
    color: #969696;
  }
  .alarm-content{
    left: 10px;
    top: 649px;
    .content-body {
      width: 480px;
      height: 382px;
      background-color: rgba(4,30,48,0.5);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AlarmMonitor.vue